<h4 style="font-weight: bold; margin-top: 0px">{{ modalTitle || 'Insect + Substrate' }}</h4>
<div class="grid">
  <div class="col-6">
    <app-insect-item
      *ngIf="catalogInformation"
      [catalogInformation]="catalogInformation"
      [editingOrderItemInsectVariant]="editingOrderItemInsectVariant"
      [editingInstance]="editingInstance"
      [editingMode]="editingMode"
      (insectItemChangeEvent)="onReceiveInsectData($event)"
      [editingOrderItemDetails]="editingOrderItemDetails">
    </app-insect-item>
  </div>
  <div class="col-6">
    <app-container-infestation-rate
      [isDisabled]="containerDisabled"
      [catalogInformation]="catalogInformation"
      [editingOrderItemContainerInfestation]="editingOrderItemContainerInfestation"
      [selectedCatalogInsectGrowthStageId]="selectedCatalogInsectGrowthStageId"
      [editingInstance]="editingInstance"
      [editingMode]="editingMode"
      [reset]="insectInfestationReset"
      [numberOfContainers]="numberOfContainers"
      (containerItemChangeEvent)="onReceiveContainerData($event)"></app-container-infestation-rate>
  </div>
</div>
<div class="grid">
  <div class="col-6">
    <app-substrate-item
      [catalogInformation]="catalogInformation"
      [filteredSubstrates]="filteredSubstrates"
      [units]="units"
      [selectedContainerId]="orderInsectSubstrate.container"
      [isDisabled]="substrateDisabled"
      [editingOrderItemSubstrate]="editingOrderItemSubstrate"
      [editingInstance]="editingInstance"
      [editingMode]="editingMode"
      [reset]="substrateReset"
      [selectedContainerId]="orderInsectSubstrate.container"
      [selectedContainerTypeName]="getSelectedContainerTypeName()"
      (substrateItemChangeEvent)="onReceiveSubstrateData($event)">
    </app-substrate-item>
  </div>
  <div class="col-6">
    <div class="grid mt-1px">
      <div class="col-12">
        <p-floatlabel variant="on" class="w-full">
          <p-treeselect
            [options]="locationNodes"
            [(ngModel)]="selectedLocationNode"
            data-testid="insectSubstrateLocation"
            containerStyleClass="w-full"
            class="required"
            appendTo="body"
            (onNodeSelect)="onLocationNodeSelect($event)">
          </p-treeselect>
          <label for="on_label">Delivery Location</label>
        </p-floatlabel>
      </div>
    </div>
    <div class="grid mt-1px" *ngIf="!editingInstance">
      <div class="col-12">
        <p-floatlabel variant="on">
          <p-select
            #projectSelect
            appLockInitialWidth
            fluid="true"
            [options]="projects"
            [(ngModel)]="orderInsectSubstrate.projectId"
            data-testid="project"
            optionLabel="ProjectName"
            optionValue="ProjectId"
            filter="true"
            appendTo="body"
            pTooltip="{{ projectTooltipText }}"
            tooltipPosition="right"
            tooltipStyleClass="custom-tooltip"
            filterPlaceholder="Search Cost Center"></p-select>
          <label for="on_label">Cost Center</label>
        </p-floatlabel>
      </div>
    </div>
    <div class="grid mt-1px">
      <div class="col">
        <div class="flex align-content-center flex-wrap">
          <div class="flex align-items-center justify-content-center mr-2" *ngIf="!editingInstance || (editingInstance && editingMode === 'single')">
            <p-floatlabel variant="on">
              <p-datepicker
                class="required"
                id="deliveryDate"
                [(ngModel)]="orderInsectSubstrate.deliveryDate"
                [minDate]="minDate"
                [maxDate]="maxDate"
                showIcon
                iconDisplay="input"
                data-testId="deliveryDate"
                appendTo="body"
                [disabledDates]="unavailableDates"
                [disabledDays]="invalidDays"
                [disabled]="
                  !insectVarGrowSubSelected ||
                  (!editingInstance && selectedDates && selectedDates.length > 1) ||
                  (editingInstance && editingMode === 'future' && selectedDates && selectedDates.length > 1)
                "
                (onSelect)="onDeliveryDateChange()"
                (onInput)="onDeliveryDateChange()"></p-datepicker>
              <label for="on_label">Delivery Date</label>
            </p-floatlabel>
          </div>
          <div *ngIf="showRecurringDatesTooltip" class="flex align-items-center justify-content-center">
            <span
              class="pi pi-info-circle mr-1"
              pTooltip="{{ recurringDatesTooltip }}"
              tooltipPosition="top"
              tooltipStyleClass="custom-tooltip"
              style="font-size: 1.2em; cursor: pointer">
            </span>
          </div>
          <div *ngIf="showMakeRecurringButton" class="flex align-items-center justify-content-center">
            <p-button
              [label]="status === 'Updated' || status === 'Approved' ? 'Reschedule Recurrences' : 'Make Recurring'"
              icon="pi pi-sync"
              severity="primary"
              [raised]="true"
              (click)="openMakeRecurringDialog()"
              data-testid="makeRecurring"
              [disabled]="!insectVarGrowSubSelected" />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="grid mt-1px">
  <div class="col-12">
    <p-floatlabel variant="on">
      <textarea pTextarea data-testid="note" [(ngModel)]="orderInsectSubstrate.note" rows="8" style="resize: none" class="w-full h-full"></textarea>
      <label for="on_label">Notes</label>
    </p-floatlabel>
  </div>
</div>
<div class="border-top-1 surface-border pt-2 flex justify-content-between w-full">
  <p-button label="Cancel" icon="fa fa-times" severity="danger" size="small" [raised]="true" (click)="onCancel()" data-testid="newItemCancel" />
  <p-button
    *ngIf="showAddButton"
    label="Add"
    icon="fa fa-check"
    severity="success"
    size="small"
    [raised]="true"
    (click)="onSaveOrderItem()"
    data-testid="newItemSave"
    [disabled]="!isInsectSubstrateFormValid" />
  <p-button
    *ngIf="!showAddButton"
    label="Save"
    icon="fa fa-check"
    severity="success"
    size="small"
    [raised]="true"
    (click)="onEditSaveOrderItem()"
    data-testid="newItemSave"
    [disabled]="!isInsectSubstrateFormValid" />
</div>

<p-dialog
  [modal]="true"
  [showHeader]="true"
  [position]="'center'"
  [closeOnEscape]="false"
  [closable]="false"
  [(visible)]="showRecurringDialog"
  appendTo="body"
  (onHide)="showRecurringDialog = false"
  (onShow)="onDialogShow()"
  [style]="{ 'width': '70vw' }">
  <ng-template #header>
    <h4><strong>Build Recurrence Schedule</strong></h4>
  </ng-template>
  <div class="grid">
    <div class="col-4">
      <app-recurrence-schedule
        #recurrenceComp
        [minDate]="minDate"
        [maxDate]="maxDate"
        [invalidDays]="invalidDays"
        [invalidDates]="unavailableDates"
        [invalidDatesStr]="unavailableDatesIsoStrings"
        [firstDeliveryDate]="firstDeliveryDate"
        [invalidRecurrenceDates]="invalidRecurringDates"
        [recurrenceSchedule]="recurrenceSchedule"
        (updateRecurrences)="updateRecurrences($event)"></app-recurrence-schedule>
    </div>
    <div class="col-8">
      <app-calendar
        #calendarComp
        [minDate]="minDate"
        [maxDate]="maxDate"
        [invalidDays]="invalidDays"
        [invalidDates]="unavailableDatesIsoStrings"
        [selectedDates]="selectedDates"
        [invalidRecurrenceDates]="invalidRecurringDates"
        (updateRecurrences)="updateRecurrences($event)"></app-calendar>
    </div>
  </div>
  <ng-template #footer>
    <div
      class="border-top-1 surface-border pt-2 flex justify-content-end flex-wrap w-full"
      *ngIf="editingInstance && (status === 'Updated' || status === 'Approved')">
      <div class="flex flex-wrap">
        <div class="flex align-items-center justify-content-center mr-1">
          <p-button
            label="Cancel"
            icon="fa fa-cancel"
            severity="danger"
            size="small"
            [raised]="true"
            data-testid="cancelRecurrences"
            (click)="cancelRecurrences()" />
        </div>
        <div class="flex align-items-center justify-content-center">
          <p-button
            label="Save Recurrences"
            icon="fa fa-check"
            severity="success"
            size="small"
            [raised]="true"
            data-testid="addRecurrences"
            (click)="addRecurrences()" />
        </div>
      </div>
    </div>
    <div
      class="border-top-1 surface-border pt-2 flex justify-content-between flex-wrap w-full"
      *ngIf="!editingInstance || (editingInstance && status !== 'Updated' && status !== 'Approved')">
      <div class="flex align-items-center justify-content-center">
        <p-button
          label="Remove Recurrences"
          icon="fa fa-times"
          severity="danger"
          size="small"
          [raised]="true"
          data-testid="removeRecurrences"
          (click)="removeRecurrences()" />
      </div>
      <div class="flex flex-wrap">
        <div class="flex align-items-center justify-content-center mr-1">
          <p-button
            label="Cancel"
            icon="fa fa-cancel"
            severity="danger"
            size="small"
            [raised]="true"
            data-testid="cancelRecurrences"
            (click)="cancelRecurrences()" />
        </div>
        <div class="flex align-items-center justify-content-center">
          <p-button
            label="Save Recurrences"
            icon="fa fa-check"
            severity="success"
            size="small"
            [raised]="true"
            data-testid="addRecurrences"
            (click)="addRecurrences()" />
        </div>
      </div>
    </div>
  </ng-template>
</p-dialog>

<app-processing [visible]="isProcessing"></app-processing>
